import {
  Table,
  Col,
  Card,
  Space,
  Typography,
  Radio,
  Spin,
  Input,
  Tooltip,
  Popover,
} from "antd";
import {
  ToolTypes,
  getLiveGraphData,
  addGraphLiveData,
  checkSubscriptionLevel,
  getUser,
  updateUser,
  getUserDeleteToken,
  deleteUser,
  getRecipientShares,
  updateRecipient,
  cancelSubscription,
  checkPayMethod,
  createPayMethod,
  setDefaultPM,
  deletePayMethod,
  retrieveInvoices,
  createSubscription,
} from "../../API";
import { Row, Text, View, Icon, Graph, Alert, Button } from "../../Components";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  large,
  Images,
} from "../../global";
import { ArrowLeftOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { Auth } from "aws-amplify";
import { useEffect, useState, useRef } from "react";
import { useRecoilState } from "recoil";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useMatch } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as analogIcon } from "../../Assets/SVG/Analog_Small.svg";
import { ReactComponent as therm4Icon } from "../../Assets/SVG/4Ch_Small.svg";
import { ReactComponent as chemIcon } from "../../Assets/SVG/ChemSense_Small.svg";
import { ReactComponent as swimIcon } from "../../Assets/SVG/SwimSense_Small.svg";
import { ReactComponent as thpIcon } from "../../Assets/SVG/THP_Small.svg";
import { ReactComponent as toolIcon } from "../../Assets/SVG/ToolIcon_Small.svg";
import { ReactComponent as addIcon } from "../../Assets/SVG/AddTool_Small.svg";
import { ReactComponent as troubleshootIcon } from "../../Assets/SVG/Troubleshoot_Small.svg";
import { ReactComponent as userSmallIcon } from "../../Assets/SVG/User_Small.svg";
import { ReactComponent as appearanceIcon } from "../../Assets/SVG/Appearance_Small.svg";
import { ReactComponent as emailIcon } from "../../Assets/SVG/Email.svg";
import { ReactComponent as phoneIcon } from "../../Assets/SVG/Phone.svg";
import { ReactComponent as passIcon } from "../../Assets/SVG/Password.svg";
import { ReactComponent as newsIcon } from "../../Assets/SVG/Newsletter.svg";
import { ReactComponent as signOutIcon } from "../../Assets/SVG/SignOut.svg";
import { ReactComponent as userIcon } from "../../Assets/SVG/User.svg";
import { ReactComponent as deleteIcon } from "../../Assets/SVG/Trash_Small.svg";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options2.svg";
import _ from "lodash";
import "./Settings.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import HelperService from "../../Helpers/HelperService";
const monthlyPlan = "price_1Ne0cEGj4W74K3goX912tX3g";
const yearlyPlan = "price_1Ne0cEGj4W74K3goWgpXNg4f";
const invoiceColumns = [
  {
    title: "Date",
    dataIndex: "created",
    key: "created",
    render: (date) => (
      <Text as={"small"} color={"darkGrey"}>
        {new Date(date * 1000).toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
        })}
      </Text>
    ),
  },
  {
    title: "Invoice Number",
    dataIndex: "number",
    key: "number",
    render: (number) => (
      <Text as={"small"} color={"darkGrey"}>
        {number}
      </Text>
    ),
  },
  {
    title: "Amount",
    dataIndex: "total",
    key: "total",
    render: (total) => (
      <Text as={"small"} color={"darkGrey"}>
        {"$" + total / 100}
      </Text>
    ),
  },
  {
    title: "Method",
    dataIndex: "id",
    key: "id",
    render: () => (
      <Text as={"small"} color={"darkGrey"}>
        {"Credit Card"}
      </Text>
    ),
  },
  // {
  // title: '',
  // dataIndex: 'id',
  // key: 'id',
  // render: () => <Icon svg={optionsIcon} color={Colors.darkGrey} size='sm' />,
  // }
];

let content1 = <></>;
let content2 = <></>;
let content3 = <></>;
let tempDefaultPM = null;
function Settings() {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const [dbUser, setDbUser] = useState(allSites.user);
  const [subscriptionLevel, setSubscriptionLevel] = useState(null);
  const [invoices, setInvoices] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [checkSubscription, setCheckSubscription] = useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [name, setName] = useState(dbUser?.settings?.account?.fullName);
  const [subscription, setSubscription] = useState(
    dbUser?.settings?.account?.newsletterSubscription
  );
  const [recipientShares, setRecipientShares] = useState(
    allSites["recipientShares"]
  );
  const [currentShareID, setCurrentShareID] = useState(undefined);
  const [acceptShare, setAcceptShare] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [acceptInitiated, setAcceptInitiated] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [rejectInitiated, setRejectInitiated] = useState(false);
  // const activeSite = Object.values(allSites).flatMap(arr => arr).find(obj => obj.mac === macAddress)
  const navigate = useNavigate();
  let previousEmail = user?.attributes?.email;
  // if(user?.attributes?.email) email = user?.attributes?.email
  function errorCheck(type) {
    let errorsFound = false;
    if (email == "" && type == "email") {
      errorsFound = true;
      setEmailError("Required");
    }
    if (code == "" && type == "verify") {
      errorsFound = true;
      setCodeError("Required");
    }
    if (type == "password") {
      if (oldPassword == "") {
        errorsFound = true;
        setOldPasswordError("Required");
      }
      if (newPassword == "") {
        errorsFound = true;
        setNewPasswordError("Required");
      }
      if (confirmPassword == "") {
        errorsFound = true;
        setConfirmPasswordError("Required");
      }
      if (newPassword != confirmPassword) {
        errorsFound = true;
        setConfirmPasswordError("Must Match 'New Password'");
      }
    }
    if (errorsFound) {
      return false;
    }
    return true;
  }

  const [emailError, setEmailError] = useState("");
  const [email, setEmail] = useState(previousEmail);
  const [error, setError] = useState("");
  const [emailButtonLoading, setEmailButtonLoading] = useState(false);
  const [code, setCode] = useState("");
  const [codeVisible, setCodeVisible] = useState(false);
  const [verifyVisible, setVerifyVisible] = useState(false);
  const [codeError, setCodeError] = useState("");
  const [verifyButtonLoading, setVerifyButtonLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneButtonLoading, setPhoneButtonLoading] = useState(false);
  const [phoneVisible, setPhoneVisible] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [hideOldPassword, setOldHidePassword] = useState(false);
  const [hideNewPassword, setNewHidePassword] = useState(false);
  const [hideConfirmPassword, setConfirmHidePassword] = useState(false);
  const [passButtonLoading, setPassButtonLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState("");
  const [deleteToken, setDeleteToken] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [hidePassword, setHidePassword] = useState(false);
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const [deleteInitiated, setDeleteInitiated] = useState(false);
  const [getTokenError, setGetTokenError] = useState(false);
  const [confirmInitiated, setConfirmInitiated] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmButtonLoading, setConfirmButtonLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [value, setValue] = useState("Yearly");
  const [defaultPayment, setDefaultPayment] = useState(null);
  const [subNav, setSubNav] = useState("subscription");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [deleteCardLoading, setDeleteCardLoading] = useState(false);
  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [makeDefaultLoading, setMakeDefaultLoading] = useState(false);
  const [showCardInput, setShowCardInput] = useState(false);
  const [saveCardLoading, setSaveCardLoading] = useState(false);
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const [showPaymentError, setShowPaymentError] = useState(false);
  const billingRate = ["Yearly", "Monthly"];
  const [tableHeight, setTableHeight] = useState();
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpiry, setCardExpiry] = useState("");
  const [cardCode, setCardCode] = useState("");
  const [cardZip, setCardZip] = useState("");
  const [cardErrors, setCardErrors] = useState({
    name: "",
    number: "",
    expiry: "",
    code: "",
    zip: "",
  });
  const [cardCreateError, setCardCreateError] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const cvcRef = useRef();

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (entries[0].contentRect.height > 0)
        setTableHeight(entries[0].contentRect.height - 142);
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => ref.current && observer.unobserve(ref.current);
  }, [ref.current, subNav]);
  console.log("AllSites Settings:", allSites);
  // useEffect(() => {
  //     if(macAddress && activeSite) {
  //         tableData.forEach((obj) => {
  //             console.log(obj)
  //             // getToolInfo({token: user.signInUserSession.idToken.jwtToken, mac: macAddress, uid: , pid:}).then((data) => {
  //             //     console.log("HERE")
  //             // }).catch((err) => {console.log("Error: ", err)});
  //         })
  //     }
  // }, []);
  const handleCardDisplay = () => {
    const rawText = [...cardNumber.split(" ").join("")]; // Remove old space
    const creditCard = []; // Create card as array
    rawText.forEach((t, i) => {
      if (cardNumber.startsWith(3)) {
        //Amex
        if (i == 4 || i == 10) creditCard.push(" ");
      } else if (i % 4 === 0 && i !== 0) creditCard.push(" "); // Add space
      creditCard.push(t);
    });
    return creditCard.join(""); // Transform card array to string
  };
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const getSubLevel = async () => {
    let subResult = await checkSubscriptionLevel(
      user.signInUserSession.idToken.jwtToken
    ).then((subLevel) => subLevel);
    console.log("Sub Level Result:", subResult);
    let invoiceResult = await retrieveInvoices().then((res) => res);
    console.log("Invoice Result:", invoiceResult);
    let paymentResult = await checkPayMethod().then((res) => res);
    console.log("Payment Result:", paymentResult);
    setSubscriptionLevel(subResult);
    setDefaultPayment(paymentResult?.default_payment_method);
    setPaymentMethods(paymentResult?.data);
    setInvoices(invoiceResult);
    setSubscriptionLoading(false);
  };
  const cancelSub = async () => {
    let result = await cancelSubscription().then((res) => res);
    console.log("cancelSub Result:", result);
    await getSubLevel();
    setCancelLoading(false);
    setShowCancel(false);
  };
  const deleteCard = async () => {
    let result = await deletePayMethod(showDeleteCard.id).then((res) => res);
    console.log("deletePayMethod Result:", result);
    await getSubLevel();
    setDeleteCardLoading(false);
    setShowDeleteCard(false);
  };
  const makeDefault = async () => {
    let result = await setDefaultPM(tempDefaultPM).then((res) => res);
    console.log("setDefaultPM Result:", result);
    await getSubLevel();
    setMakeDefaultLoading(false);
  };
  const subscribe = async () => {
    let tierType;
    if (value == "Monthly") {
      tierType = "tier_one_monthly";
    } else if (value == "Yearly") {
      tierType = "tier_one_yearly";
    }
    let result = await createSubscription(tierType).then((res) => res);
    console.log("createSubscription Result:", result);
    await getSubLevel();
    setSubscribeLoading(false);
  };
  const saveCard = async () => {
    // Check errors
    let errors = { name: "", number: "", expiry: "", code: "", zip: "" };
    setCardCreateError("");
    if (cardName.length == 0) errors.name = "Required";
    if (cardNumber.length == 0) errors.number = "Required";
    if (
      (!cardNumber.startsWith(3) && cardNumber.length < 16) || //Card length
      (cardNumber.startsWith(3) && cardNumber.length < 15) || //Amex card length
      (!cardNumber.startsWith(4) && //Card type
        !cardNumber.startsWith(3) &&
        !cardNumber.startsWith(6) &&
        !cardNumber.startsWith(5))
    )
      errors.number = "Invalid";
    if (cardExpiry.length == 0) errors.expiry = "Required";
    if (cardExpiry.length < 5) errors.expiry = "Invalid";
    if (cardCode.length == 0) errors.code = "Required";
    if (
      (cardNumber.startsWith(3) && cardCode.length < 4) ||
      (!cardNumber.startsWith(3) && cardCode.length < 3)
    ) {
      errors.code = "Invalid";
    }
    if (cardZip.length == 0) errors.zip = "Required";
    if (cardZip.length < 5) errors.zip = "Invalid";
    //If Errors
    if (
      errors.name.length > 0 ||
      errors.number.length > 0 ||
      errors.expiry.length > 0 ||
      errors.code.length > 0 ||
      errors.zip.length > 0
    ) {
      setCardErrors(errors);
    } else {
      let cardObject = {
        type: "card",
        number: "",
        exp_month: null,
        exp_year: null,
        cvc: "",
      };
      // cardObject.name = cardName
      cardObject.number = cardNumber.split(" ").join("");
      cardObject.exp_month = Number(cardExpiry.split("/")[0]);
      cardObject.exp_year = Number("20" + cardExpiry.split("/")[1]);
      cardObject.cvc = cardCode;
      // cardObject.zip = cardZip
      console.log("Parsed Card Object:", cardObject);
      let result = await createPayMethod(cardObject).then((res) => res);
      console.log("createPayMethod Result:", result);
      if (result == true) {
        await getSubLevel();
        setCardName("");
        setCardNumber("");
        setCardExpiry("");
        setCardCode("");
        setCardZip("");
        setCardErrors({ name: "", number: "", expiry: "", code: "", zip: "" });
        setShowCardInput(false);
      } else {
        console.log("Error creating card:", result);
        try {
          if (_.has(result, "errors")) setCardCreateError(result.errors);
          if (_.has(result, "errorMessage"))
            setCardCreateError(result.errorMessage);
        } catch (error) {
          console.log("Unexpected Error", error);
          setCardCreateError("Unexpected error while adding card");
        }
      }
    }
    setSaveCardLoading(false);
  };
  const pullRecipientShares = async () => {
    if (user.signInUserSession.idToken.jwtToken) {
      let recipentShares = await getRecipientShares({
        token: user.signInUserSession.idToken.jwtToken,
      }).then((data) => {
        console.log("data:", data);
        return data;
      });
      let tempAllSites = _.cloneDeep(allSites);
      // tempAllSites['recipentShares'] = recipentShares
      tempAllSites["repull"] = true;
      console.log("pullRecipientShares Updating AllSites to ", tempAllSites);
      setAllSites(tempAllSites);
      // setRecipientShares(recipentShares)
    }
  };
  useEffect(() => {
    console.log("useEffect deleteStatus");
    if (deleteStatus == "" && confirmInitiated) {
      setConfirmButtonLoading(true);
    } else if (_.has(deleteStatus, "Error")) {
      setConfirmButtonLoading(false);
      if (confirmInitiated) setDeleteError(true);
      setConfirmInitiated(false);
    } else {
      if (confirmInitiated) {
        setConfirmButtonLoading(false);
        setConfirmInitiated(false);
        navigate("/");
        setAllSites({});
        signOut();
      }
    }
  }, [deleteStatus, setConfirmButtonLoading]);
  useEffect(() => {
    const startDeleteUser = async () => {
      console.log("useEffect confirmButtonLoading");
      if (confirmButtonLoading && confirmInitiated) {
        try {
          let tempResponse = deleteUser(
            user.signInUserSession.idToken.jwtToken,
            deleteToken.deleteToken
          );
          setDeleteStatus(tempResponse);
        } catch (error) {
          console.log("deleteUser ERROR:", error);
        }
      }
    };
    startDeleteUser();
  }, [confirmButtonLoading, confirmInitiated]);
  useEffect(() => {
    console.log("useEffect deleteToken");
    if (deleteToken == "" && deleteInitiated) {
      setDeleteButtonLoading(true);
    } else if (_.has(deleteToken, "Error")) {
      setDeleteButtonLoading(false);
      if (deleteInitiated) setGetTokenError(true);
      setDeleteInitiated(false);
    } else if (_.has(deleteToken, "deleteToken")) {
      if (deleteToken && deleteInitiated) {
        setDeleteButtonLoading(false);
        setDeleteInitiated(false);
        navigate("/settings/account/deleteConfirm");
      }
    }
  }, [deleteToken, setDeleteButtonLoading]);
  useEffect(() => {
    const getDeleteToken = async () => {
      console.log("useEffect deleteButtonLoading");
      if (deleteButtonLoading && deleteInitiated) {
        try {
          let tempDeleteToken = await getUserDeleteToken(
            user.signInUserSession.idToken.jwtToken,
            password
          );
          setDeleteToken(tempDeleteToken);
        } catch (error) {
          console.log("getUserDeleteToken ERROR:", error);
        }
      }
    };
    getDeleteToken();
  }, [deleteButtonLoading, deleteInitiated]);
  useEffect(() => {
    const getDBUser = async () => {
      if (
        user &&
        _.has(user, "signInUserSession") &&
        _.has(user.signInUserSession, "idToken") &&
        _.has(user.signInUserSession.idToken, "jwtToken")
      ) {
        let dbUser = await getUser(
          user.signInUserSession.idToken.jwtToken
        ).then((userData) => userData);
        setDbUser(dbUser);
        setName(dbUser?.settings?.account?.fullName);
        setSubscription(dbUser?.settings?.account?.newsletterSubscription);
        console.log("getDBUser Updating AllSites to ", {
          ...allSites,
          user: dbUser,
        });
        setAllSites({ ...allSites, user: dbUser });
        // pullRecipientShares()
      }
    };
    getDBUser();
  }, []);

  useEffect(() => {
    if (subscriptionLoading) {
      try {
        getSubLevel();
      } catch (error) {
        console.log("checkSubscription ERROR:", error);
      }
    }
  }, [subscriptionLoading]);
  useEffect(() => {
    if (cancelLoading) {
      try {
        cancelSub();
      } catch (error) {
        console.log("cancelSub ERROR:", error);
      }
    }
  }, [cancelLoading]);
  useEffect(() => {
    if (deleteCardLoading) {
      try {
        deleteCard();
      } catch (error) {
        console.log("deleteCard ERROR:", error);
      }
    }
  }, [deleteCardLoading]);
  useEffect(() => {
    if (makeDefaultLoading) {
      try {
        makeDefault();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [makeDefaultLoading]);
  useEffect(() => {
    if (saveCardLoading) {
      try {
        saveCard();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [saveCardLoading]);
  useEffect(() => {
    if (subscribeLoading) {
      try {
        subscribe();
      } catch (error) {
        console.log("makeDefault ERROR:", error);
      }
    }
  }, [subscribeLoading]);

  useEffect(() => {
    if (acceptLoading) {
      try {
        updateRecipient(
          user.signInUserSession.idToken.jwtToken,
          currentShareID,
          { shareNotify: true, acceptState: true }
        ).then(() => {
          setAcceptLoading(false);
          setRejectLoading(false);
          pullRecipientShares();
        });
      } catch (error) {
        console.log("DELETE ERROR:", error);
      }
    } else {
      if (acceptInitiated) {
        setAcceptShare(false);
        setAcceptInitiated(false);
        setCurrentShareID(undefined);
      }
    }
  }, [acceptLoading, acceptInitiated]);
  useEffect(() => {
    if (rejectLoading) {
      try {
        updateRecipient(
          user.signInUserSession.idToken.jwtToken,
          currentShareID,
          { shareNotify: true, acceptState: false }
        ).then(() => {
          setAcceptLoading(false);
          setRejectLoading(false);
          pullRecipientShares();
        });
      } catch (error) {
        console.log("DELETE ERROR:", error);
      }
    } else {
      if (rejectInitiated) {
        setAcceptShare(false);
        setRejectInitiated(false);
        setCurrentShareID(undefined);
      }
    }
  }, [rejectLoading, rejectInitiated]);

  useEffect(() => {
    console.log("ALL SITES UPDATED ON SETTINGS PAGE");
    setRecipientShares(allSites["recipientShares"]);
  }, [allSites]);
  // if(activeSite?.data_id === undefined) {
  //     return null;
  // }

  if (allSites.tools) {
    content1 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          flex: 1,
          overflow: "auto",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={"Settings"} />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
          }}
        >
          {/* <Row.SettingLink         
                title="Add New Tool"
                symbol = {addIcon}
                onPress = {() => {console.log('Add Tool Clicked')}}/> */}
          <Row.SettingLink
            title="Account"
            symbol={userSmallIcon}
            onPress={() => {
              navigate(`/settings/account`);
            }}
          />
          {/* <Row.SettingLink          
                    title="Appearance"
                    symbol={appearanceIcon}
                    onPress = {() => {}}/> */}
          <Row.SettingLink
            title="Troubleshooting"
            symbol={troubleshootIcon}
            onPress={() => {
              window.open("https://stratus.gitbook.io/stratus");
            }}
          />
          {allSites.tools.length > 0 ? (
            <View>
              <Row.Section title="Tool Settings" />
              {allSites.tools.map((item, index) => (
                <Row.SettingLink
                  key={item.key}
                  symbol={
                    item.toolType == ToolTypes.THP ||
                    item.toolType == ToolTypes.SDP
                      ? thpIcon
                      : item.toolType == ToolTypes.ANALOG_4_CH
                      ? analogIcon
                      : item.toolType == ToolTypes.THERMO_4_CH
                      ? therm4Icon
                      : item.toolType == ToolTypes.SWIM
                      ? swimIcon
                      : item.toolType == ToolTypes.CHEM
                      ? chemIcon
                      : toolIcon
                  }
                  title={item.label}
                  // onPress = {() => {
                  //     navigate('/toolSettings/'+item.key)
                  // }}
                  onPress={
                    recipientShares &&
                    recipientShares.get(item.key) &&
                    recipientShares.get(item.key).recipientSettings
                      .acceptState != true
                      ? () => {
                          console.log("ITEM:", item);
                          setCurrentShareID(item.key);
                          setAcceptShare(true);
                        }
                      : () => {
                          console.log("ITEM:", item);
                          navigate("/toolSettings/" + item.key);
                        }
                  }
                />
              ))}
            </View>
          ) : (
            <></>
          )}
        </View>
      </View>
    );
  }

  if (window?.location?.pathname.includes("email")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Change Email" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <Row.AuthInput
            label="Email Address"
            icon={emailIcon}
            value={email}
            setValue={setEmail}
            error={emailError}
            setError={setEmailError}
          />
          <Text color="error" weight="light">
            {error}
          </Text>
          <View
            style={{
              height: 50,
              justifyContent: "center",
              width: "100%",
              ...Metrics.smallBottomMargin,
            }}
          >
            <Button
              style={Metrics.smallTopMargin}
              isLoading={emailButtonLoading}
              disabled={previousEmail == email}
              text="Verify"
              variant="primary"
              onPress={async () => {
                if (previousEmail != email) {
                  setError("");
                  setEmailButtonLoading(true);
                  if (errorCheck("email")) {
                    try {
                      await Auth.currentAuthenticatedUser().then((user) => {
                        return Auth.updateUserAttributes(user, {
                          email: email,
                        });
                      });
                      updateUser(user.signInUserSession.idToken.jwtToken, {
                        account: { email: email },
                      });
                      navigate(`/settings/account/verify`);
                    } catch (error) {
                      console.log(error);
                      switch (error.code) {
                        default:
                          setError(error.message);
                          break;
                      }
                    }
                  }
                  setEmailButtonLoading(false);
                }
              }}
            />
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("verify")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Verify New Email" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <View
            style={[
              Helpers.mainStart,
              Helpers.crossCenter,
              Metrics.mediumHorizontalMargin,
              { flexDirection: "column" },
            ]}
          >
            <Text style={Metrics.mediumTopMargin} as="large">
              {"Enter verification code sent to " + email}
            </Text>
            <Row.AuthInput
              style={Metrics.smallTopMargin}
              label="Verification Code"
              value={code}
              setValue={setCode}
              error={codeError}
              setError={setCodeError}
            />
            <Text color="error" weight="light">
              {error}
            </Text>
            <Button
              style={Metrics.smallTopMargin}
              text="Proceed"
              variant="primary"
              isLoading={verifyButtonLoading}
              onPress={async () => {
                setError("");
                setVerifyButtonLoading(true);
                if (errorCheck("verify")) {
                  try {
                    const user = await Auth.verifyCurrentUserAttributeSubmit(
                      "email",
                      code
                    );
                    setVerifyVisible(true);
                  } catch (error) {
                    console.log("verification err:", error);
                    switch (error.code) {
                      case "CodeMismatchException":
                        setCodeVisible(true);
                        break;
                      default:
                        setError(error.message);
                        break;
                    }
                  }
                }
                setVerifyButtonLoading(false);
              }}
            />
            <Text style={Metrics.mediumTopMargin} color="primary">
              Didn't receive code?
            </Text>
            <View
              onClick={() => {
                try {
                  Auth.resendSignUp(email).catch((error) =>
                    setError(error.message)
                  );
                } catch (error) {
                  setError(error.message);
                }
              }}
            >
              <Text style={{ cursor: "pointer" }} color="highlight">
                Resend Code
              </Text>
            </View>
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("phone")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Change Phone Number" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <PhoneInput
            placeholder="Phone Number"
            value={phone}
            onChange={(text) => {
              console.log("Updated number:", text);
              setPhone(text);
            }}
          />
          <Text color="error" weight="light">
            {error}
          </Text>
          <View
            style={{
              height: 50,
              justifyContent: "center",
              width: "100%",
              ...Metrics.smallBottomMargin,
            }}
          >
            <Button
              style={Metrics.smallTopMargin}
              isLoading={phoneButtonLoading}
              text="Save"
              variant="primary"
              onPress={async () => {
                setError("");
                setPhoneButtonLoading(true);
                try {
                  await Auth.currentAuthenticatedUser().then((user) => {
                    return Auth.updateUserAttributes(user, {
                      phone_number: phone,
                    });
                  });
                  updateUser(user.signInUserSession.idToken.jwtToken, {
                    account: { phone: phone },
                  });
                  setPhoneVisible(true);
                } catch (error) {
                  console.log(error);
                  switch (error.code) {
                    default:
                      setError(error.message);
                      break;
                  }
                }
                setPhoneButtonLoading(false);
              }}
            />
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("pass")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Change Password" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <Row.AuthInput
            label="Old Password"
            icon={passIcon}
            value={oldPassword}
            setValue={setOldPassword}
            hidden={hideOldPassword}
            setHidden={setOldHidePassword}
            error={oldPasswordError}
            setError={setOldPasswordError}
          />
          <Row.AuthInput
            label="New Password"
            icon={passIcon}
            value={newPassword}
            setValue={setNewPassword}
            hidden={hideNewPassword}
            setHidden={setNewHidePassword}
            error={newPasswordError}
            setError={setNewPasswordError}
          />
          <Row.AuthInput
            label="Confirm New Password"
            icon={passIcon}
            value={confirmPassword}
            setValue={setConfirmPassword}
            hidden={hideConfirmPassword}
            setHidden={setConfirmHidePassword}
            error={confirmPasswordError}
            setError={setConfirmPasswordError}
          />
          <Text color="error" weight="light">
            {error}
          </Text>
          <View
            style={{
              height: 50,
              justifyContent: "center",
              width: "100%",
              ...Metrics.smallBottomMargin,
            }}
          >
            <Button
              style={Metrics.smallTopMargin}
              isLoading={passButtonLoading}
              text="Change Password"
              variant="primary"
              onPress={async () => {
                setError("");
                setPassButtonLoading(true);
                if (errorCheck("password")) {
                  try {
                    await Auth.currentAuthenticatedUser().then((user) => {
                      return Auth.changePassword(
                        user,
                        oldPassword,
                        newPassword
                      );
                    });
                    setPasswordVisible(true);
                  } catch (error) {
                    console.log(error);
                    switch (error.code) {
                      case "NotAuthorizedException":
                        setOldPasswordError("Incorrect Password");
                        break;
                      case "LimitExceededException":
                        setError("Please try again in a few minutes");
                        break;
                      case "InvalidPasswordException":
                        setNewPasswordError("Invalid New Password");
                      default:
                        setError(error.message);
                        break;
                    }
                  }
                }
                setPassButtonLoading(false);
              }}
            />
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("delete")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Delete Account and Data" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <View
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                borderRadius: 5,
                border: "2px solid",
                borderColor: Colors.error,
              }}
            >
              <Text as="xlarge" color={"error"} weight={"bold"}>
                {"Warning:"}
              </Text>
              <Text style={{ paddingLeft: 5 }} as="xlarge" color={"error"}>
                {"This action cannot be undone."}
              </Text>
            </View>
            <Text
              style={{ paddingTop: 20, paddingBottom: 20 }}
              as="large"
              color={"darkGrey"}
            >
              {"\nThe following will occur if you delete your account:\n"}
            </Text>
            <Text as="large" color="darkGrey">
              {
                "• You will lose access to any Stratus devices and services associated with the closed account, and your data cannot be restored. "
              }
            </Text>
            <Text as="large" color="darkGrey">
              {
                "• Your active units will go offline and will stop logging. You will need to add them to a new account to restart logging.  "
              }
            </Text>
            <Text as="large" color="darkGrey">
              {
                "• You will lose access to any current Stratus subscriptions. All active subscriptions will be immediately stopped and if applicable, a prorated refund will be applied to the credit card on file.  "
              }
            </Text>
            <Text as="large" color="darkGrey">
              {
                "• You will lose access to any Stratus Data Files. Any required data should be exported to other formats and stored on your local device before account is deleted.  "
              }
            </Text>
            <Text
              style={{ paddingTop: 20, paddingBottom: 20 }}
              as="large"
              color={"darkGrey"}
            >
              {"\nEnter password below to continue:\n"}
            </Text>
          </View>
          <View
            style={{
              height: 130,
              justifyContent: "center",
              width: "100%",
              ...Metrics.smallBottomMargin,
            }}
          >
            <Row.AuthInput
              label="Password"
              icon={emailIcon}
              value={password}
              setValue={setPassword}
              hidden={hidePassword}
              setHidden={setHidePassword}
              error={passwordError}
              setError={setPasswordError}
            />
            <Text color="error" weight="light">
              {error}
            </Text>
            <Button
              style={Metrics.smallTopMargin}
              isLoading={deleteButtonLoading}
              disabled={password == ""}
              text="Delete Account and Data"
              variant="primary"
              onPress={async () => {
                setError("");
                try {
                  setDeleteInitiated(true);
                  setDeleteButtonLoading(true);
                } catch (error) {
                  console.log(error);
                  switch (error.code) {
                    default:
                      setError(error.message);
                      break;
                  }
                }
              }}
            />
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("deleteConfirm")) {
    content3 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Delete Account Confirmation" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <View style={{ width: "100%" }}>
            <Row.Checkbox
              noBorder
              title={"Delete Account"}
              icon={deleteIcon}
              channelColor={Colors.lightGrey}
              value={confirmation}
              label={
                "Are you sure you want to permanently delete the account? All data will be lost and this step cannot be undone. "
              }
              onValueChange={(newValue) => {
                setConfirmation(newValue.target.checked);
              }}
            />
          </View>
          <View
            style={{
              height: 50,
              justifyContent: "center",
              alignSelf: "center",
              width: "87%",
              ...Metrics.smallBottomMargin,
            }}
          >
            <Button
              style={Metrics.smallTopMargin}
              isLoading={confirmButtonLoading}
              disabled={!confirmation}
              text="Delete Account and Data"
              variant="primary"
              onPress={() => {
                setConfirmInitiated(true);
                setConfirmButtonLoading(true);
              }}
            />
          </View>
        </View>
      </View>
    );
  } else if (window?.location?.pathname.includes("subscription")) {
    if (subscriptionLevel == null && !subscriptionLoading) {
      setSubscriptionLoading(true);
    }
    if (subscriptionLoading) {
      content3 = (
        <View
          style={{
            ...Helpers.colCross,
            flex: 1,
            height: "100%",
            width: "100%",
          }}
        >
          <View style={{ overflow: "none", width: "100%" }}>
            <Row.PageTitle title={""} />
            <Row.Section title="Subscription" />
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              flex: 1,
              overflow: "auto",
              borderLeft: "2px solid",
              borderLeftColor: Colors.light,
            }}
          >
            <Spin style={{ marginTop: Spacing.sm }} size="large" />
          </View>
        </View>
      );
    } else if (Array.isArray(subscriptionLevel)) {
      //Pro Subscription subscriptionLevel.length > 0 && _.isObject(subscriptionLevel[0]) && subscriptionLevel[0].plan.active && _.has(subscriptionLevel[0].plan,'product') && subscriptionLevel[0].plan.product.startsWith('prod_')
      content3 = (
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            overflow: "hidden",
          }}
        >
          <View style={{ overflow: "none" }}>
            <Row.PageTitle title={""} />
            <Row.Section title="Subscription" />
          </View>
          <View
            style={[
              Helpers.row,
              Metrics.smallHorizontalMargin,
              Metrics.smallVerticalMargin,
              { justifyContent: "space-between", overflow: "none" },
            ]}
          >
            <Text
              onClick={() => setSubNav("subscription")}
              style={{ cursor: "pointer" }}
              as={"xlarge"}
              weight={subNav == "subscription" ? "bold" : "medium"}
            >
              {"Subscription"}
            </Text>
            <Text
              onClick={() => setSubNav("payment")}
              style={{ cursor: "pointer" }}
              as={"xlarge"}
              weight={subNav == "payment" ? "bold" : "medium"}
            >
              {"Payment Methods"}
            </Text>
            <Text
              onClick={() => setSubNav("invoice")}
              style={{ cursor: "pointer" }}
              as={"xlarge"}
              weight={subNav == "invoice" ? "bold" : "medium"}
            >
              {"Invoices"}
            </Text>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              flex: 1,
              overflow: "auto",
              borderLeft: "2px solid",
              borderLeftColor: Colors.light,
            }}
          >
            {subNav == "subscription" ? (
              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  flex: 1,
                }}
              >
                <Row.Value
                  title="Stratus Plus"
                  icon={userIcon}
                  color={Colors.primary}
                  value={
                    subscriptionLevel[0]?.plan?.active ? "Active" : "Inactive"
                  }
                />
                {subscriptionLevel[0]?.plan?.active ? (
                  <Row.Value
                    title="Billing Frequency"
                    // icon={null}
                    // color={Colors.primary}
                    value={
                      subscriptionLevel[0]?.plan?.id == monthlyPlan
                        ? "Monthly"
                        : subscriptionLevel[0]?.plan?.id == yearlyPlan
                        ? "Annually"
                        : "--"
                    }
                  />
                ) : (
                  <></>
                )}
                {subscriptionLevel[0]?.plan?.active ? (
                  <Row.Value
                    title="Next Billing Date"
                    // icon={null}
                    // color={Colors.primary}
                    value={
                      subscriptionLevel[0]?.current_period_end
                        ? new Date(
                            subscriptionLevel[0].current_period_end * 1000
                          ).toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })
                        : "--"
                    }
                  />
                ) : (
                  <></>
                )}
                {subscriptionLevel[0]?.plan?.active ? (
                  <View
                    style={{
                      display: "flex",
                      height: 50,
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      ...Metrics.tinyVerticalMargin,
                    }}
                  >
                    <Button
                      text="Cancel Subscription"
                      variant="primary"
                      onPress={async () => {
                        setShowCancel(true);
                      }}
                    />
                  </View>
                ) : (
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      flex: 1,
                      overflow: "auto",
                      borderLeft: "2px solid",
                      borderLeftColor: Colors.light,
                    }}
                  >
                    <View
                      style={[
                        Helpers.textCenter,
                        Metrics.smallVerticalPadding,
                        Metrics.smallHorizontalMargin,
                        Metrics.smallVerticalMargin,
                        {
                          backgroundColor: Colors.secondary20,
                          borderRadius: 10,
                        },
                      ]}
                    >
                      <Text weight={"bold"} as="xxlarge">
                        TRY FREE FOR 1 MONTH
                      </Text>
                    </View>
                    <View
                      style={[Helpers.column, Metrics.smallHorizontalMargin]}
                    >
                      <View style={[Helpers.textCenter]}>
                        <Text weight={"bold"} color={"darkGrey"}>
                          {"$0 for first month"}
                        </Text>
                      </View>
                      <Text style={Metrics.smallTopMargin} color={"darkGrey"}>
                        {
                          "Higher Resolution of Data Logging. Data log at rates up to 1 sample per minute."
                        }
                      </Text>
                      <Text style={Metrics.smallTopMargin} color={"darkGrey"}>
                        {"Share Tools for direct access with other users."}
                      </Text>
                      <Text style={Metrics.smallTopMargin} color={"darkGrey"}>
                        {
                          "Group multiple tools for time synchronized graphing and control."
                        }
                      </Text>
                      <Text style={Metrics.smallTopMargin} color={"darkGrey"}>
                        {"Automatic PDF/Excel Report Generation."}
                      </Text>
                      <Text style={Metrics.smallTopMargin} color={"darkGrey"}>
                        {"Raw Data Logs never expire."}
                      </Text>
                      <Text
                        style={Metrics.smallVerticalMargin}
                        color={"darkGrey"}
                      >
                        {"Direct Save to Google Sheets."}
                      </Text>
                    </View>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space style={{ width: "100%" }} direction="vertical">
                        {billingRate.map((item, index) => (
                          <View
                            onClick={(e) => {
                              e.stopPropagation();
                              onChange({ target: { value: item } });
                            }}
                            style={[
                              Helpers.row,
                              Metrics.tinyVerticalPadding,
                              Metrics.smallHorizontalMargin,
                              Metrics.tinyBottomMargin,
                              Metrics.smallHorizontalPadding,
                              {
                                backgroundColor: Colors.secondary20,
                                borderRadius: 10,
                                cursor: "pointer",
                              },
                            ]}
                          >
                            <View style={Helpers.fillCol}>
                              <Text weight={"bold"} as="xlarge">
                                {item}
                              </Text>
                              <Text weight={"bold"} color={"darkGrey"}>
                                {item == "Yearly"
                                  ? "$99.99/year ($8.33/month) after trial"
                                  : "$9.99/month after trial"}
                              </Text>
                            </View>
                            <Radio
                              onClick={(e) => e.stopPropagation()}
                              value={item}
                            ></Radio>
                          </View>
                        ))}
                      </Space>
                    </Radio.Group>
                    <View
                      style={{
                        display: "flex",
                        height: 50,
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        ...Metrics.tinyVerticalMargin,
                      }}
                    >
                      <Button
                        text="Subscribe Free for 1 Month"
                        isLoading={subscribeLoading}
                        variant="primary"
                        onPress={async () => {
                          if (defaultPayment) {
                            setSubscribeLoading(true);
                          } else {
                            setShowPaymentError(true);
                          }
                        }}
                      />
                    </View>
                    <Text
                      style={[
                        Metrics.smallHorizontalMargin,
                        Helpers.textCenter,
                      ]}
                      color={"darkGrey"}
                    >
                      {
                        "By clicking the Subscribe button you agree to the Stratus Subscription Terms of Service."
                      }
                    </Text>
                  </View>
                )}
              </View>
            ) : subNav == "payment" ? (
              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  flex: 1,
                }}
              >
                {paymentMethods && paymentMethods.length > 0 ? (
                  paymentMethods.map((item, index) => (
                    <View
                      style={{
                        ...Helpers.rowCross,
                        height: 110,
                        borderBottom: "2px solid",
                        borderBottomColor: Colors.light,
                      }}
                    >
                      <img
                        style={{ width: 64, margin: Spacing.sm }}
                        src={
                          item.card.brand == "visa" ? (
                            Images.visa
                          ) : item.card.brand == "amex" ? (
                            Images.amex
                          ) : item.card.brand == "discover" ? (
                            Images.discover
                          ) : item.card.brand == "mastercard" ? (
                            Images.mastercard
                          ) : (
                            <></>
                          )
                        }
                        resizeMode={"contain"}
                      />
                      <View
                        style={[
                          Helpers.column,
                          { flex: 1, paddingLeft: Spacing.sm },
                        ]}
                      >
                        <Text color={"darkGrey"}>
                          {"Ending in " + item.card.last4}
                        </Text>
                        <Text color={"darkGrey"}>
                          {item.card.brand.charAt(0).toUpperCase() +
                            item.card.brand.slice(1)}
                        </Text>
                      </View>
                      <View
                        style={[
                          Helpers.column,
                          {
                            height: "100%",
                            width: "30%",
                            justifyContent: "space-around",
                          },
                        ]}
                      >
                        <View
                          style={[
                            Helpers.center,
                            Helpers.textCenter,
                            { height: "50%" },
                          ]}
                        >
                          {defaultPayment == item.id ? (
                            <Text color={"darkGrey"} weight={"bold"}>
                              {"Default"}
                            </Text>
                          ) : (
                            <Button
                              style={Metrics.horizontalPadding}
                              isLoading={
                                makeDefaultLoading && tempDefaultPM == item.id
                              }
                              text="Make Default"
                              variant="primary"
                              onPress={async () => {
                                tempDefaultPM = item.id;
                                setMakeDefaultLoading(true);
                              }}
                            />
                          )}
                        </View>
                        <View
                          style={[
                            Helpers.center,
                            Helpers.textCenter,
                            { height: "50%" },
                          ]}
                        >
                          <Button
                            style={Metrics.horizontalPadding}
                            text="Delete Card"
                            variant="primary"
                            onPress={async () => {
                              setShowDeleteCard(item);
                            }}
                          />
                        </View>
                      </View>
                    </View>
                  ))
                ) : (
                  <Text style={Metrics.smallVerticalMargin} color={"darkGrey"}>
                    {"There are no credit cards associated with this account."}
                  </Text>
                )}
                {showCardInput ? (
                  <View
                    style={[
                      Helpers.column,
                      Metrics.smallHorizontalMargin,
                      Metrics.verticalMargin,
                    ]}
                  >
                    <View style={[Helpers.colCenter]}>
                      <img
                        style={{ width: "70%", margin: Spacing.sm }}
                        src={Images.cards}
                      />
                    </View>
                    <Text
                      style={{ paddingLeft: Spacing.sm }}
                      as="medium"
                      color="darkGrey"
                      weight="light"
                    >
                      {"Name on Card"}
                    </Text>
                    <Input
                      style={{
                        textAlign: "left",
                        color: Colors.darkGrey,
                        paddingLeft: 10,
                        ...Fonts.medium,
                        fontFamily: "Inter-Regular",
                        flex: 1,
                        overflow: "hidden",
                      }} //medium
                      value={cardName}
                      placeholder={cardErrors.name.length > 0 ? "Required" : ""}
                      status={cardErrors.name.length > 0 ? "error" : ""}
                      onChange={(event) => {
                        if (cardErrors.name.length > 0)
                          setCardErrors({ ...cardErrors, name: "" });
                        setCardName(event.target.value);
                      }}
                    />
                    <Text
                      style={{ paddingLeft: Spacing.sm }}
                      as="medium"
                      color="darkGrey"
                      weight="light"
                    >
                      {"Card Number"}
                    </Text>
                    <Input
                      style={{
                        textAlign: "left",
                        color: Colors.darkGrey,
                        paddingLeft: 10,
                        ...Fonts.medium,
                        fontFamily: "Inter-Regular",
                        flex: 1,
                        overflow: "none",
                      }} //medium
                      value={handleCardDisplay()}
                      placeholder={
                        cardErrors.number.length > 0 ? "Required" : ""
                      }
                      status={cardErrors.number.length > 0 ? "error" : ""}
                      onChange={(event) => {
                        console.log("Number Edit Event:", event);
                        let targetValue;
                        if (cardErrors.number.length > 0)
                          setCardErrors({ ...cardErrors, number: "" });
                        if (event?.nativeEvent?.inputType == "insertText") {
                          if (
                            !isNaN(Number(event?.nativeEvent?.data)) &&
                            event?.nativeEvent?.data != " "
                          )
                            targetValue = event.target.value;
                        } else if (
                          event?.nativeEvent?.inputType == "insertFromPaste"
                        ) {
                          let pastedText = event?.target?.value
                            .split(" ")
                            .join("");
                          if (!isNaN(Number(pastedText)) && pastedText != " ")
                            targetValue = pastedText;
                        } else {
                          targetValue = event.target.value;
                        }
                        if (targetValue != undefined) {
                          console.log("Target Value:", targetValue);
                          targetValue = targetValue.split(" ").join("");
                          if (cardNumber.startsWith(3)) {
                            //Amex
                            if (targetValue.length > 15)
                              targetValue = targetValue.slice(0, 15);
                          } else if (targetValue.length > 16) {
                            targetValue = targetValue.slice(0, 16);
                          }
                          return setCardNumber(targetValue);
                        }
                        return;
                      }}
                      suffix={
                        <View
                          style={{
                            ...Helpers.center,
                            height: 35,
                            overflow: "hidden",
                          }}
                        >
                          <img
                            style={{
                              height: cardNumber.startsWith(4)
                                ? 20
                                : cardNumber.startsWith(3)
                                ? 60
                                : cardNumber.startsWith(6)
                                ? 30
                                : 40,
                              margin: Spacing.sm,
                            }}
                            src={
                              cardNumber.startsWith(4)
                                ? Images.visa
                                : cardNumber.startsWith(3)
                                ? Images.amex
                                : cardNumber.startsWith(6)
                                ? Images.discover
                                : cardNumber.startsWith(5)
                                ? Images.mastercard
                                : null
                            }
                            resizeMode={""}
                          />
                        </View>
                      }
                    />
                    <Space.Compact style={{ ...Helpers.fillRow }}>
                      <View style={{ ...Helpers.fillCol }}>
                        <Text
                          style={{ paddingLeft: Spacing.sm }}
                          as="medium"
                          color="darkGrey"
                          weight="light"
                        >
                          {"Expiry Date"}
                        </Text>
                        <Input
                          style={{
                            textAlign: "left",
                            color: Colors.darkGrey,
                            paddingLeft: 10,
                            ...Fonts.medium,
                            fontFamily: "Inter-Regular",
                            flex: 1,
                            overflow: "hidden",
                          }} //medium
                          value={cardExpiry}
                          placeholder={
                            cardErrors.expiry.length > 0 ? "Required" : "MM/YY"
                          }
                          status={cardErrors.expiry.length > 0 ? "error" : ""}
                          onChange={(event) => {
                            console.log("Value:", event);
                            if (cardErrors.expiry.length > 0)
                              setCardErrors({ ...cardErrors, expiry: "" });
                            let targetValue;
                            if (
                              event?.nativeEvent?.inputType ==
                              "deleteContentBackward"
                            ) {
                              if (event.target.value.length == 2) {
                                targetValue = event.target.value.slice(0, 1);
                              } else {
                                targetValue = event.target.value;
                              }
                            } else if (
                              event?.nativeEvent?.inputType == "insertText"
                            ) {
                              if (
                                !isNaN(Number(event?.nativeEvent?.data)) &&
                                event?.nativeEvent?.data != " "
                              ) {
                                if (event.target.value.length == 2) {
                                  targetValue = event.target.value + "/";
                                } else {
                                  targetValue = event.target.value;
                                }
                              }
                            } else if (
                              event?.nativeEvent?.inputType == "insertFromPaste"
                            ) {
                              let pastedText = event?.target?.value
                                .split("/")
                                .join("");
                              if (
                                !isNaN(Number(pastedText)) &&
                                pastedText != " "
                              ) {
                                targetValue = pastedText;
                                if (pastedText.length == 2) {
                                  targetValue = pastedText + "/";
                                } else if (pastedText.length > 2) {
                                  targetValue =
                                    pastedText.slice(0, 2) +
                                    "/" +
                                    pastedText.slice(2);
                                } else {
                                  targetValue = pastedText;
                                }
                              }
                            } else {
                              targetValue = event.target.value;
                            }
                            if (targetValue != undefined) {
                              if (targetValue.length > 5) {
                                targetValue = targetValue.slice(0, 5);
                              }
                              return setCardExpiry(targetValue);
                            }
                            return;
                          }}
                        />
                      </View>
                      <View style={{ ...Helpers.fillCol, overflow: "hidden" }}>
                        <Text
                          style={{ paddingLeft: Spacing.sm }}
                          as="medium"
                          color="darkGrey"
                          weight="light"
                        >
                          {"Security Code"}
                        </Text>
                        <Input
                          style={{
                            textAlign: "left",
                            color: Colors.darkGrey,
                            paddingLeft: 10,
                            ...Fonts.medium,
                            fontFamily: "Inter-Regular",
                            flex: 1,
                            overflow: "hidden",
                          }} //medium
                          value={cardCode}
                          placeholder={
                            cardErrors.code.length > 0 ? "Required" : ""
                          }
                          status={cardErrors.code.length > 0 ? "error" : ""}
                          onChange={(event) => {
                            if (cardErrors.code.length > 0)
                              setCardErrors({ ...cardErrors, code: "" });
                            let targetValue;
                            if (
                              event?.nativeEvent?.inputType ==
                              "deleteContentBackward"
                            ) {
                              targetValue = event.target.value;
                            } else if (
                              event?.nativeEvent?.inputType == "insertText" &&
                              !isNaN(Number(event?.nativeEvent?.data)) &&
                              event?.nativeEvent?.data != " "
                            ) {
                              targetValue = event.target.value;
                            } else if (
                              event?.nativeEvent?.inputType == "insertFromPaste"
                            ) {
                              if (!isNaN(Number(event?.target?.value)))
                                targetValue = event.target.value;
                            } else {
                              targetValue = event.target.value;
                            }
                            if (targetValue != undefined) {
                              if (cardNumber.startsWith(3)) {
                                if (targetValue.length > 4)
                                  targetValue = targetValue.slice(0, 4);
                              } else if (targetValue.length > 3) {
                                targetValue = targetValue.slice(0, 3);
                              }
                              return setCardCode(targetValue);
                            }
                            return;
                          }}
                          suffix={
                            <Popover
                              open={open}
                              color={Colors.darkGrey}
                              content={
                                cardNumber.startsWith(3) ? (
                                  <View>
                                    <Text color={"white"}>
                                      {
                                        "The 4 digits on the front of your card."
                                      }
                                    </Text>
                                    <View
                                      style={{
                                        ...Helpers.row,
                                        justifyContent: "space-around",
                                        marginTop: Spacing.sm,
                                      }}
                                    >
                                      <img height={100} src={Images.amexCVV} />
                                    </View>
                                  </View>
                                ) : cardNumber.startsWith(4) ||
                                  cardNumber.startsWith(6) ||
                                  cardNumber.startsWith(5) ? (
                                  <View>
                                    <Text color={"white"}>
                                      {"The 3 digits on the back of your card."}
                                    </Text>
                                    <View
                                      style={{
                                        ...Helpers.row,
                                        justifyContent: "space-around",
                                        marginTop: Spacing.sm,
                                      }}
                                    >
                                      <img height={100} src={Images.cardCVV} />
                                    </View>
                                  </View>
                                ) : (
                                  <View>
                                    <Text color={"white"}>
                                      {
                                        "For Visa, MasterCard, or Discover, the 3 digits on the back of your card.\n\nFor American Express, the 4 digits on the front of your card."
                                      }
                                    </Text>
                                    <View
                                      style={{
                                        ...Helpers.row,
                                        justifyContent: "space-around",
                                        marginTop: Spacing.sm,
                                      }}
                                    >
                                      <img height={100} src={Images.cardCVV} />
                                      <img height={100} src={Images.amexCVV} />
                                    </View>
                                  </View>
                                )
                              }
                              arrow={{ pointAtCenter: true }}
                              placement="topRight"
                            >
                              <QuestionCircleFilled
                                onMouseEnter={() => setOpen(true)}
                                onMouseLeave={() => setOpen(false)}
                                ref={cvcRef}
                                style={{
                                  ...Helpers.center,
                                  height: 28,
                                  color: Colors.lightGrey,
                                }}
                              />
                            </Popover>
                          }
                        />
                      </View>
                    </Space.Compact>
                    <Text
                      style={{ paddingLeft: Spacing.sm }}
                      as="medium"
                      color="darkGrey"
                      weight="light"
                    >
                      {"ZIP/Postal Code"}
                    </Text>
                    <Input
                      style={{
                        textAlign: "left",
                        color: Colors.darkGrey,
                        paddingLeft: 10,
                        ...Fonts.medium,
                        fontFamily: "Inter-Regular",
                        flex: 1,
                        overflow: "hidden",
                      }} //medium
                      value={cardZip}
                      placeholder={cardErrors.zip.length > 0 ? "Required" : ""}
                      status={cardErrors.zip.length > 0 ? "error" : ""}
                      onChange={(event) => {
                        let targetValue;
                        if (cardErrors.zip.length > 0)
                          setCardErrors({ ...cardErrors, zip: "" });
                        if (
                          event?.nativeEvent?.inputType ==
                          "deleteContentBackward"
                        ) {
                          targetValue = event.target.value;
                        } else if (
                          event?.nativeEvent?.inputType == "insertText" &&
                          !isNaN(Number(event?.nativeEvent?.data)) &&
                          event?.nativeEvent?.data != " "
                        ) {
                          targetValue = event.target.value;
                        } else if (
                          event?.nativeEvent?.inputType == "insertFromPaste"
                        ) {
                          if (!isNaN(Number(event?.target?.value)))
                            targetValue = event.target.value;
                        } else {
                          targetValue = event.target.value;
                        }

                        if (targetValue != undefined) {
                          if (targetValue.length > 5) {
                            targetValue = targetValue.slice(0, 5);
                          }
                          return setCardZip(targetValue);
                        }
                        return;
                      }}
                      suffix={
                        <Tooltip
                          color={Colors.darkGrey}
                          title="Enter the ZIP/Postal code for your credit card's billing address."
                          arrow={{ pointAtCenter: true }}
                          placement="topRight"
                        >
                          <QuestionCircleFilled
                            style={{ color: Colors.lightGrey }}
                          />
                        </Tooltip>
                      }
                    />
                    <Text as={"small"} color={"error"}>
                      {cardCreateError}
                    </Text>
                    <View style={[Helpers.rowCross]}>
                      <Button
                        style={[
                          Metrics.horizontalPadding,
                          Metrics.smallTopMargin,
                        ]}
                        disabled={saveCardLoading}
                        text="Cancel"
                        variant="primary-transparent"
                        onPress={async () => {
                          setCardName("");
                          setCardNumber("");
                          setCardExpiry("");
                          setCardCode("");
                          setCardZip("");
                          setCardErrors({
                            name: "",
                            number: "",
                            expiry: "",
                            code: "",
                            zip: "",
                          });
                          setShowCardInput(false);
                        }}
                      />
                      <Button
                        style={[
                          Metrics.horizontalPadding,
                          Metrics.smallTopMargin,
                        ]}
                        text="Save Card"
                        isLoading={saveCardLoading}
                        variant="primary"
                        onPress={async () => {
                          setSaveCardLoading(true);
                        }}
                      />
                    </View>
                  </View>
                ) : (
                  <View
                    style={[
                      Metrics.tinyHorizontalMargin,
                      Metrics.verticalMargin,
                    ]}
                  >
                    <Button
                      style={[Metrics.horizontalPadding]}
                      text="Add New Card"
                      variant="primary"
                      onPress={async () => {
                        setShowCardInput(true);
                      }}
                    />
                  </View>
                )}
              </View>
            ) : subNav == "invoice" ? (
              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div
                  ref={ref}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {invoices && invoices.length > 0 ? (
                    <Table
                      style={{ height: tableHeight }}
                      columns={invoiceColumns}
                      dataSource={invoices}
                      sticky={true}
                      virtual={true}
                      scroll={{ y: tableHeight }}
                    />
                  ) : (
                    <Text
                      style={Metrics.smallVerticalMargin}
                      color={"darkGrey"}
                    >
                      {"There are no invoices associated with this account."}
                    </Text>
                  )}
                </div>
              </View>
            ) : (
              <></>
            )}
          </View>
        </View>
      );
    } else {
      //Error
      content3 = (
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
          }}
        >
          <View style={{ overflow: "none" }}>
            <Row.PageTitle title={""} />
            <Row.Section title="Subscription" />
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              flex: 1,
              overflow: "auto",
              borderLeft: "2px solid",
              borderLeftColor: Colors.light,
            }}
          >
            <Text style={Metrics.smallVerticalMargin} color={"error"}>
              {"Unable to Get Subscription Level."}
            </Text>
          </View>
        </View>
      );
    }
  }
  if (window?.location?.pathname.includes("account")) {
    content2 = (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
        }}
      >
        <View style={{ overflow: "none" }}>
          <Row.PageTitle title={""} />
          <Row.Section title="Account" />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: "auto",
            borderLeft: "2px solid",
            borderLeftColor: Colors.light,
          }}
        >
          <Row.Setting
            title="Full Name"
            icon={userIcon}
            color={Colors.lightGrey}
            setting={name}
            changeSetting={setName}
            setSetting={() =>
              updateUser(user.signInUserSession.idToken.jwtToken, {
                account: { fullName: name },
              })
            }
          />
          <Row.SettingLink
            title="Email"
            symbol={emailIcon}
            color={Colors.lightGrey}
            label={user.attributes.email}
            onPress={() => navigate(`/settings/account/email`)}
          />
          <Row.SettingLink
            title="Phone"
            symbol={phoneIcon}
            color={Colors.lightGrey}
            label={user.attributes.phone_number}
            onPress={() => navigate(`/settings/account/phone`)}
          />
          <Row.SettingLink
            title="Password"
            symbol={passIcon}
            color={Colors.lightGrey}
            label={"Change Password"}
            onPress={() => navigate(`/settings/account/pass`)}
          />
          <Row.Checkbox
            title={"Stay Up To Date"}
            icon={newsIcon}
            channelColor={Colors.lightGrey}
            value={subscription}
            label={
              "Stay up to date on the latest Stratus products, features, and promotions."
            }
            onValueChange={(newValue) => {
              setSubscription(newValue.target.checked);
              updateUser(user.signInUserSession.idToken.jwtToken, {
                account: { newsletterSubscription: newValue.target.checked },
              });
            }}
          />
          <Row.SettingLink
            title="Subscription"
            symbol={userIcon}
            color={Colors.lightGrey}
            onPress={() => {
              setSubscriptionLoading(true);
              navigate(`/settings/account/subscription`);
              // setCheckSubscription(true)
            }}
          />
          <Row.SettingLink
            title="Delete Account and Data"
            symbol={deleteIcon}
            colorAll={Colors.error}
            onPress={() => navigate(`/settings/account/delete`)}
          />
        </View>
      </View>
    );
    if (window?.location?.pathname.endsWith("account")) content3 = <></>;
  } else {
    content2 = <></>;
    content3 = <></>;
  }

  return (
    <View style={{ height: "calc(100vh - 80px)", overflow: "clip" }}>
      <View style={[Helpers.row, { height: "100%" }]}>
        {content1}
        {content2}
        {content3}
      </View>
      <Alert
        visible={checkSubscription}
        setVisible={setCheckSubscription}
        title="Subscription Level"
        text={
          subscriptionLoading
            ? "Getting Subscription Level."
            : _.has(subscriptionLevel, "errors")
            ? "Unable to get Subscription Level."
            : Array.isArray(subscriptionLevel) &&
              subscriptionLevel.length > 0 &&
              _.isObject(subscriptionLevel[0]) &&
              subscriptionLevel[0].plan.active &&
              _.has(subscriptionLevel[0].plan, "product") &&
              subscriptionLevel[0].plan.product.startsWith("prod_")
            ? "Subscription Level: Pro."
            : Array.isArray(subscriptionLevel) && subscriptionLevel.length == 0
            ? "Subscription Level: Standard."
            : "Unknown Error."
        }
        loading={subscriptionLoading}
        oneButton={true}
        onPress={async () => {
          if (!subscriptionLoading) setCheckSubscription(false);
        }}
      ></Alert>
      <Alert
        visible={codeVisible}
        setVisible={() => {}}
        oneButton={true}
        title="Incorrect Code"
        text="Please check the confirmation code and try again"
        onPress={() => {
          setCodeVisible(false);
        }}
      ></Alert>
      <Alert
        visible={verifyVisible}
        setVisible={() => {}}
        oneButton={true}
        title="Email Verified"
        text="You have successfully verified your email"
        onPress={() => {
          setVerifyVisible(false);
          navigate("/settings/account");
        }}
      ></Alert>
      <Alert
        visible={phoneVisible}
        setVisible={() => {}}
        oneButton={true}
        title="Phone Number Changed"
        text="You have successfully changed your phone number"
        onPress={() => {
          setPhoneVisible(false);
          navigate("/settings/account");
        }}
      ></Alert>
      <Alert
        visible={passwordVisible}
        setVisible={() => {}}
        oneButton={true}
        title="Password Changed"
        text="You have successfully changed your password"
        onPress={() => {
          setPasswordVisible(false);
          navigate("/settings/account");
        }}
      ></Alert>
      <Alert
        visible={getTokenError}
        setVisible={setGetTokenError}
        title="Account Delete Request Error"
        text={deleteToken.Error}
        oneButton={true}
        onPress={() => {
          setGetTokenError(false);
        }}
      />
      <Alert
        visible={deleteError}
        setVisible={setDeleteError}
        title="Account Delete Request Error"
        text={deleteStatus.Error}
        oneButton={true}
        onPress={() => {
          setDeleteError(false);
        }}
      />
      <Alert
        visible={acceptShare}
        setVisible={setAcceptShare}
        title="Tool Sharing Request"
        loading={acceptLoading || rejectLoading}
        text={
          recipientShares && currentShareID
            ? recipientShares.get(currentShareID).recipientSettings
                .senderEmailID + " is attempting to share a tool with you"
            : ""
        }
        button={
          <Button
            style={{ width: "48%" }}
            isLoading={acceptLoading}
            disabled={rejectLoading}
            text={"Accept"}
            variant="primary"
            onPress={() => {
              setAcceptLoading(true);
              setAcceptInitiated(true);
            }}
          />
        }
        button2={
          <Button
            style={{ width: "48%" }}
            isLoading={rejectLoading}
            text={"Reject"}
            disabled={acceptLoading}
            variant="primary-transparent"
            onPress={() => {
              setRejectLoading(true);
              setRejectInitiated(true);
            }}
          />
        }
      />
      <Alert
        visible={showCancel}
        loading={cancelLoading}
        setVisible={setShowCancel}
        title="Cancel Subscription"
        text={"Are you sure you want to cancel your Stratus Plus subscription?"}
        onPress={() => {
          setCancelLoading(true);
        }}
      />
      <Alert
        visible={showDeleteCard}
        loading={deleteCardLoading}
        setVisible={setShowDeleteCard}
        title="Delete Card"
        text={`Are you sure you want to delete your ${
          showDeleteCard?.card?.brand.charAt(0).toUpperCase() +
          showDeleteCard?.card?.brand.slice(1)
        } card ending with ${showDeleteCard?.card?.last4}`}
        onPress={() => {
          setDeleteCardLoading(true);
        }}
      />
      <Alert
        visible={showPaymentError}
        setVisible={setShowPaymentError}
        title="No Default Payment"
        text={
          "Please add a default payment method before subscribing to Stratus Pro."
        }
        oneButton={true}
        onPress={() => {
          setSubNav("payment");
          setShowPaymentError(false);
        }}
      />
    </View>
  );
  return (
    // <Space size={20} direction="vertical" style={{width: "100%"}}>
    //     <div className="controls">
    //         <Typography.Title level={4}>
    //             <span onClick={() => { navigate(`/site/${macAddress}`) }}>
    //                 <ArrowLeftOutlined style={{marginRight: 10}}/>
    //             </span>
    //             Settings
    //         </Typography.Title>
    //         <Table style={{paddingTop: 20}} columns={columns} dataSource={tableData} rowKey="uid" />
    //     </div>
    // </Space>
    <View style={{ width: "100%", height: "100%" }}>
      <Row.PageTitle title={"Settings"} />
      {/* <Row.SettingLink         
        title="Add New Tool"
        symbol = {addIcon}
        onPress = {() => {console.log('Add Tool Clicked')}}/> */}
      <Row.SettingLink title="Account" symbol={userIcon} onPress={() => {}} />
      {/* <Row.SettingLink          
        title="Appearance"
        symbol={appearanceIcon}
        onPress = {() => {}}/> */}
      <Row.SettingLink
        title="Troubleshooting"
        symbol={troubleshootIcon}
        onPress={() => {
          window.open("https://stratus.gitbook.io/stratus");
        }}
      />

      <Row.Section title="Tool Settings" />
      {/* {toolOnAccount ? (
        Array.from(tools.values()).map((item,index) =>(
          _.has(item,'mac')?
          <Row.SettingLink
            key = {item.mac}
            symbol = {item.toolType == ToolTypes.THP || item.toolType == ToolTypes.SDP?thpIcon:
                      item.toolType == ToolTypes.ANALOG_4_CH?analogIcon:
                      item.toolType == ToolTypes.THERMO_4_CH?therm4Icon:
                      item.toolType == ToolTypes.SWIM?swimIcon:
                      item.toolType == ToolTypes.CHEM?chemIcon:toolIcon}  
            title = {item.settings.toolName}
            onPress = {() => NavigationService.navigate('ToolSettings',{mac:item.mac,appHeader:true})}
          />:<></>
        ))
      ):(<Text
        color="darkGrey"
        style={{ ...Helpers.textCenter, ...Fonts.normal, ...Metrics.smallVerticalPadding }}
      >
        No tools
      </Text>)
      } */}
      {/* {recipientShares && !_.isEmpty(recipientShares)?<View>
        <Row.Section title="Shared with me"/>
        {(Array.from(recipientShares.values()).map((item,index) =>(
          _.has(item,'share_id') && tools.get(item.share_id)?
          <Row.SettingLink
            key = {item.share_id}
            symbol = {tools.get(item.share_id).toolType == ToolTypes.THP || tools.get(item.share_id).toolType == ToolTypes.SDP?thpIcon:
                      tools.get(item.share_id).toolType == ToolTypes.ANALOG_4_CH?analogIcon:
                      tools.get(item.share_id).toolType == ToolTypes.THERMO_4_CH?therm4Icon:
                      tools.get(item.share_id).toolType == ToolTypes.SWIM?swimIcon:
                      tools.get(item.share_id).toolType == ToolTypes.CHEM?chemIcon:toolIcon}  
            title = {tools.get(item.share_id).settings.toolName}
            onPress = {recipientShares.get(item.share_id).recipientSettings.acceptState == true?
              (() => NavigationService.navigate('ToolSettings',{share_id:item.share_id,appHeader:true})):
              (() => {
                setCurrentShareID(item.share_id)
                setAcceptShare(true)
              }  )
            }
          />:<Text>Issue with recipientShare...</Text>
          ))
          )
        }
      </View>:<></>}
      {currentShareID!= undefined?<Alert 
          visible={acceptShare} 
          setVisible={setAcceptShare} 
          title="Tool Sharing Request" 
          loading={acceptLoading || rejectLoading}
          text={recipientShares.get(currentShareID).recipientSettings.senderEmailID + " is attempting to share a tool with you"} 
          button={<Button
            style={styles.button}
            isLoading ={acceptLoading}
            disabled = {rejectLoading}
            text={'Accept'}
            variant="primary"
            onPress={() => {
              setAcceptLoading(true)
              setAcceptInitiated(true)
            }}
          />}
          button2={<Button
            style={styles.button}
            isLoading ={rejectLoading}
            text={'Reject'}
            disabled = {acceptLoading}
            variant="primary-transparent"
            onPress={() => {
              setRejectLoading(true)
              setRejectInitiated(true)
            }}
          />}
          />:<></>}   */}
    </View>
  );
}

export default Settings;
